import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useBrokerName } from '../../../util/hooks/userBrokerName';
import BulletItem from '../../BulletItem/BulletItem';
import BulletList from '../../BulletList/BulletList';
import Paragraph from '../../Paragraph/Paragraph';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import ContainerWithCustomScrollbar from '../../ContainerWithCustomScrollbar/ContainerWithCustomScrollbar';
import config from '../../../config';
import { selectSettings } from '../../../store/selectors/settingsSelectors';

export const MetalStreamTerms = ({ handleBack, handleNext }) => {
  const { t } = useTranslation();
  const brokerName = useBrokerName();
  const { DisplayBrokerCode, BrokerCode } = useSelector(selectSettings);
  const { metalStreamCaption } = config;

  return (
    <ContainerWithCustomScrollbar>
      <ModalBody>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textOne.one', {
            metalStream: metalStreamCaption,
          })}
          {BrokerCode === 'HAA'
            ? t('termsAndConditions.textOne.twoGBIDirect', {
                brokerName,
              })
            : t('termsAndConditions.textOne.twoGS', { brokerName })}
          {t('termsAndConditions.textOne.three')}
        </Paragraph>
        <BulletList>
          <BulletItem text={t('termsAndConditions.textTwo')} />
          <BulletItem text={t('termsAndConditions.textThree')} />
          <BulletItem text={t('termsAndConditions.textFour', { brokerName })} />
        </BulletList>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textFive', {
            metalStream: metalStreamCaption,
          })}
        </Paragraph>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textSix')}
        </Paragraph>
        <BulletList>
          <BulletItem text={t('termsAndConditions.textSeven')} />
          <BulletItem
            text={t('termsAndConditions.textEight', {
              metalStream: metalStreamCaption,
            })}
          />
          <BulletItem text={t('termsAndConditions.textNine')} />
        </BulletList>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textTen')}
        </Paragraph>
        <BulletList>
          <BulletItem text={t('termsAndConditions.textEleven')} />
          <BulletItem
            text={t('termsAndConditions.textTwelve', {
              brokerCode: DisplayBrokerCode,
              metalStream: metalStreamCaption,
            })}
          />
        </BulletList>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textThirteen')}
        </Paragraph>
        <Paragraph marginBottom={24}>
          {t('termsAndConditions.textFourteen', {
            brokerCode: DisplayBrokerCode,
            metalStream: metalStreamCaption,
          })}
        </Paragraph>

        <Paragraph>
          {' '}
          {t('termsAndConditions.textFifteen', {
            brokerCode: DisplayBrokerCode,
            metalStream: metalStreamCaption,
          })}
        </Paragraph>

        <ModalButtons
          isHorizontal
          marginTop
          smallButtons
          secondaryButtonProps={{ onClick: handleBack }}
          primaryButtonProps={{
            label: t('common.agree'),
            onClick: handleNext,
          }}
        />
      </ModalBody>
    </ContainerWithCustomScrollbar>
  );
};

MetalStreamTerms.propTypes = {
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
};
